import { render, staticRenderFns } from "./PrintPreviewAppDetailHeader.vue?vue&type=template&id=87f35994&scoped=true"
import script from "./PrintPreviewAppDetailHeader.vue?vue&type=script&lang=js"
export * from "./PrintPreviewAppDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f35994",
  null
  
)

export default component.exports